// FooterReviewer.jsx
import React from "react";
import "./FooterReviewer.css";

const FooterReviewer = () => {
  return (
    <footer className="footer-fullwidth-99ab">
      <p>
        Developed by{" "}
        <a
          href="https://drishticps.iiti.ac.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          IITI DRISHTI CPS FOUNDATION
        </a>
      </p>
    </footer>
  );
};

export default FooterReviewer;
